<template>
  <div class="page">
    <div class="page_title">网点列表</div>
    <div class="search_container">
      <div class="search_box">
        <van-icon name="search" style="color: rgba(166, 166, 166, 1)"/>
        <input class="search" type="text" placeholder="请输入网点名称/关键字" v-model="posName">
      </div>
    </div>
    <div class="page_main">
      <div class="handle_group">
        <div class="handle" @click="goAddPos">
          <i class="el-icon-document-add"></i>
          新增网点
        </div>
        <div class="center_line"></div>
        <div class="handle" @click="refresh">
          <i class="el-icon-refresh-right"></i>
          刷新
        </div>
      </div>
      <div class="table_container">
        <table class="table">
          <thead>
          <tr>
            <td>网点ID</td>
            <td>名称</td>
            <td>操作</td>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item of posList" :key="item.Id" @click="getQrCode(item)">
            <td>{{ item.pos.posId }}</td>
            <td class="tableName">{{ item.pos.name }}</td>
            <td>
              <button class="button delete" @click="deletePos(item)">删除</button>
              <button class="button edit" @click="revisePos(item)">修改</button>
            </td>
          </tr>
          </tbody>
        </table>
        <div v-if="loadMore" class="loadMore"><van-loading color="#07c160" size="24"/>加载更多</div>
        <div v-else class="loadMore">已加载所有网点</div>
      </div>
    </div>
  </div>
</template>

<script>
import { queryPosInfoList,findPartnerByPartnerId } from "../graphql/api";
import { delPos } from "../api";
import { Dialog } from 'vant';
import {generateQrcode} from "../api/axios/generate-qrcode";
export default {
  name: 'posList',
  watch:{
    posName: function (){
      console.log('posName', this.posName);
      this.posList = [];
      this.page = 1;
      this.loadMore = true;
      this.getPosList();
    }
  },
  data(){
    return{
      posList: [],
      page: 1,
      size: 20,
      loadMore: true,
      partnerName: '',
      posName: '',
    }
  },
  mounted() {
    this.getPartnerName();
    this.posList = [];
    this.getPosList();
    window.addEventListener("scroll", this.watchScroll, true);
  },
  beforeDestroy() {
    this.posList = [];
    window.removeEventListener("scroll", this.watchScroll,true);
  },
  methods:{
    // 获取商户名称
    getPartnerName(){
      findPartnerByPartnerId(sessionStorage.getItem('partnerid')).then(res => {
        this.partnerName = res.data.findPartnerByPartnerId.name;
      }).catch(error => {
        alert(`${error}`)
      })
    },

    // 监听页面滚动到底部触发分页瀑布加载
    watchScroll(e){
      // 滚动条滚动时，距离顶部的距离
      // pc端使用：document.documentElement.  移动端使用：document.body
      const scrollTop = e.target.scrollTop;
      // 可视区的高度
      const windowHeight = e.target.clientHeight;
      // 滚动条的总高度
      const scrollHeight = e.target.scrollHeight;
      if ((scrollTop + windowHeight) - scrollHeight > -1) {
        this.page++;
        console.log('滚动到页面底部');
        this.getPosList();
      }
    },

    // 获取网点列表
    getPosList(){
      console.log('this.loadMore', this.loadMore);
      if(this.loadMore){
        let params;
        if(this.posName === '' || this.posName.replace(/^\s*|\s*$/g, "") === ""){
          if(sessionStorage.getItem('zmEmployee') && sessionStorage.getItem('partnerid') === 'M2022060601'){
            params = {
              page: this.page,
              size: 20
            }
          }else{
            params = {
              partnerId: sessionStorage.getItem('partnerid'),
              page: this.page,
              size: 20
            }
          }
        }else{
          if(sessionStorage.getItem('zmEmployee')){
            params = {
              keyword: this.posName,
            }
          }else {
            params = {
              partnerId: sessionStorage.getItem('partnerid'),
              keyword: this.posName,
            }
          }
        }
        console.log('调用时的页码数', this.page);
        queryPosInfoList(params).then(res => {
          if(!res.data.queryPosInfo){
            console.log('已加载所有网点');
            this.loadMore = false;
          }else{
            let data = res.data.queryPosInfo;
            console.log(data.length, this.size);
            if(data.length < this.size){
              console.log('检测到加载完成');
              this.loadMore = false;
              this.posList = data
            }else{
              for(const item of data){
                this.posList.push(item);
              }
            }

          }
        }).catch(error => {
          alert(`异常${error}`);
        })
      }
    },

    // 新增网点
    goAddPos(){
      console.log('新增网点');
      this.$router.push('/pos_detail')
    },

    // 刷新
    refresh(){
      this.page = 1;
      this.posList = [];
      this.loadMore = true;
      this.getPosList();
      this.$notify({
        icon: 'success',
        message: '刷新成功'
      })
    },

    // 删除网点
    deletePos(item){
      console.log(item);
      Dialog.confirm({
        title: '提醒',
        message: '确认删除网点吗？'
      }).then(() =>{
        delPos(item.pos.posId).then(res => {
          console.log('删除网点响应值', res);
          if(res.data.retcode == 0){
            this.posList = this.posList.filter(itm => itm.posId != item.posId);
            this.refresh()
          }else{
            alert(`${res.data.retmsg}`)
          }
        })
      });
    },

    // 修改网点
    revisePos(item){
      console.log('修改');
      this.$router.push({
        path: '/pos_detail',
        query: {
          posId: item.pos.posId
        }
      })
    },

    //
    getQrCode(item) {
      generateQrcode({
        cmd: 'autoStart',
        deviceID: item.pos.posId,
        pageNo: '25',
        agentID: 'ZMXCL'
      }).then(res => {
        console.log('生成门店二维码', res);
      }).catch(error => {
        console.log('生成门店二维码异常', error);
      })
    }
  }
}
</script>

<style src="../css/posList.css" scoped>

</style>



// WEBPACK FOOTER //
// src/views/posList.vue